import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import useOptionConfig from '../hooks/useOptionConfig';

const QuestionBankItem = ({ question }) => {
  const navigate = useNavigate();
  const { config } = useOptionConfig();
  const labels = config?.labels?.questions || {};
  const questionDetailLabels = config?.labels?.questionDetail || {};
  const bankLabels = config?.labels?.questionBank || {};

  const {
    questionText,
    monthYears = [],
    moduleTopicId,
    isActive,
  } = question || {};

  return (
    <Card
      sx={{ mb: 2, cursor: 'pointer' }}
      onClick={() => navigate('/question-detail', { state: { question, isNewNavigation: true } })}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <Stack direction="row" spacing={1} flexWrap="wrap" gap={1} alignItems="center">
            <Chip label={`${questionDetailLabels.lblID || 'ID'}: ${question.id ?? 'N/A'}`} size="small" />
            {moduleTopicId && <Chip label={`${bankLabels.lblTopic || 'Topic'}: ${moduleTopicId}`} size="small" color="primary" />}
            {Array.isArray(monthYears) && monthYears.length > 0 && (
              <Chip
                label={monthYears.map(m => `${m.month} ${m.year}`).join(' | ')}
                size="small"
                variant="outlined"
              />
            )}
          </Stack>
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 1, flexShrink: 0 }}>
            <Chip
              label={isActive ? (labels.active || 'Active') : (labels.inactive || 'Inactive')}
              size="small"
              color={isActive ? 'success' : 'error'}
              sx={{ mr: 1 }}
            />
          </Box>
        </Box>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
          {questionText || (labels.noQuestionText || 'No question text provided.')}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default QuestionBankItem;
